import React from "react";
import PropTypes from "prop-types";
import { XeroClient } from "services";
import { withOrganisationContextConsumer } from "contexts/OrganisationContext";
import { compose, withProps } from "recompose";

const endpointMap = {
  InvoiceID: "invoices",
  CreditNoteID: "creditnotes",
  QuoteID: "quotes",
  PurchaseOrderID: "purchaseorders",
  BankTransactionID: "banktransactions"
};

const withData = compose(
  withProps((parentProps) => ({ parentProps })),
  withOrganisationContextConsumer,
  (BaseComponent) =>
    class extends React.Component {
      static propTypes = {
        item: PropTypes.shape({
          Contact: PropTypes.shape({
            ContactID: PropTypes.string.isRequired,
          }).isRequired,
        }).isRequired,
      };

      state = null;
      componentDidMount = () => {
        const {
          item,
          contactID,
          fetchOrganisation,
          fetchTaxRates,
          fetchSettings,
        } = this.props;
        const xero = XeroClient();

        let qrCode = null;
        
        const isForeignCurrency = item.CurrencyRate !== 1

        const fetchHistory = isForeignCurrency
        ? async () => {
            const entry = Object.entries(endpointMap)
              .find(([key]) => item[key]);
      
            if (!entry) return null;
      
            const [key, endpoint] = entry;
            return xero
              .get(`${endpoint}/${item[key]}/History`)
              .get("data");
          }
        : () => null;

        if (item.Type === "ACCREC") {
          qrCode = xero.post(`invoices/${item.InvoiceID}/generate_qrcode`);
        } else if (item.Type === "ACCRECCREDIT") {
          qrCode = xero.post(`creditnotes/${item.CreditNoteID}/generate_qrcode`);
        }

        Promise.props({
          item,
          qrCode: qrCode
            ? qrCode
                .get("data")
                .get("content")
                .catch((err) => {
                  console.error(err);
                  return null;
                })
            : null,
          contact: item.Contact? (
            item.Contact?.UpdatedDateUTC ? item.Contact: xero.get(`contacts/${contactID || item.Contact?.ContactID}`).get("data")
          ):{},
          organisation: fetchOrganisation(),
          taxRates: fetchTaxRates(),
          settings: fetchSettings(),
          history: fetchHistory(),
        }).then((state) => this.setState(state));
      };

      render = () => {
        return this.state ? (
          <BaseComponent {...this.props.parentProps} {...this.state} />
        ) : null;
      };
    }
);

export default withData;
